export default "__VITE_ASSET__5ed46a86__"